{
  "login": {
    "title": "Sign in",
    "email": "Work email",
    "password": "Password",
    "rememberMe": "Remember me",
    "submit": "Sign in",
    "welcomeBack": "Welcome back",
    "mfaPrompt": "Enter the code from your authenticator app",
    "mfaTitle": "Two-factor authentication",
    "mfaCode": "Authenticator code",
    "mfaVerify": "Verify",
    "backToLogin": "Back to login",
    "forgotPasswordLink": "Forgot password?",
    "notMasterAdmin": "This account is not a platform master administrator",
    "platformOperatorUrl": "Platform operators must use the master console login URL.",
    "invalidCredentials": "Invalid email or password",
    "invalidMfaCode": "Invalid authenticator code",
    "googleLogin": "Login with Google",
    "newOrganization": "New organization?",
    "createAccount": "Create account"
  },
  "forgotPassword": {
    "title": "Forgot password",
    "email": "Work email",
    "submit": "Send reset link",
    "sentTitle": "Check your email",
    "sentBody": "If the email exists, a reset link was sent. Check your inbox.",
    "sentToast": "Check your email for reset instructions",
    "backToSignIn": "Back to sign in"
  },
  "resetPassword": {
    "title": "Reset password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "submit": "Reset password",
    "success": "Password reset — you can sign in now",
    "invalidLink": "Invalid reset link",
    "failed": "Reset failed",
    "backToLogin": "Back to login",
    "passwordMin8": "Min 8 characters",
    "passwordsMismatch": "Passwords must match"
  },
  "register": {
    "intro": "Create your account — choose your products on the next screen",
    "name": "Name",
    "email": "Email",
    "phone": "Phone number",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "continue": "Continue",
    "googleSignUp": "Sign up with Google",
    "alreadyRegistered": "Already registered?",
    "login": "Login",
    "resetPassword": "Reset password",
    "passwordMin8": "At least 8 characters",
    "passwordUppercase": "Include an uppercase letter",
    "passwordLowercase": "Include a lowercase letter",
    "passwordNumber": "Include a number",
    "passwordSpecial": "Include a special character",
    "nameRequired": "Name required",
    "emailRequired": "Valid email required",
    "phoneRequired": "Phone number required",
    "passwordsMismatch": "Passwords must match",
    "alreadyRegisteredTitle": "Already registered",
    "wrongPasswordNotice": "This email is already registered, but the password is incorrect. Log in with the right password, reset it, or use a different email.",
    "passwordMismatchEmail": "Password does not match this email",
    "existingAddApp": "Your password matches — you can add {{app}} to your existing organization",
    "existingLogin": "Your password matches — log in to continue with your existing organization",
    "accountVerified": "Account verified",
    "signedInAs": "Signed in as {{email}}",
    "organization": "Organization",
    "yourApplications": "Your applications",
    "appAlreadyEnabled": "{{app}} is already on this organization. Log in to open it — no need to register again.",
    "addAppPrompt": "Add {{app}} to {{org}}? Your team keeps one login and one organization — billing and users stay unified.",
    "existingOrgPrompt": "You already have an account with {{org}}. Continue to log in — we will not create a duplicate organization.",
    "addAppButton": "Add {{app}} to {{org}}",
    "loginToOrg": "Log in to {{org}}",
    "loginWithoutAdding": "Log in without adding {{app}}",
    "goToLogin": "Go to login page",
    "useDifferentEmail": "Use a different email",
    "yourOrganization": "your organization",
    "toastWelcome": "Welcome",
    "toastWelcomeModule": "Welcome to {{module}}",
    "toastSignedIn": "Signed in to your existing account",
    "toastAppAdded": "{{app}} added to {{org}}",
    "failedRegistration": "Could not complete registration",
    "failedAddApp": "Could not add application to your organization",
    "failedLogin": "Could not log in"
  },
  "toast": {
    "profilePhotoUpdated": "Profile photo updated",
    "profilePhotoRemoved": "Profile photo removed",
    "passwordUpdatedYouCanContinueUsingTheApp": "Password updated — you can continue using the app",
    "passwordUpdated": "Password updated",
    "copied": "Copied",
    "twoFactorAuthenticationEnabled": "Two-factor authentication enabled",
    "twoFactorAuthenticationDisabled": "Two-factor authentication disabled",
    "openedModule": "Opened {{module}}"
  },
  "errors": {
    "pleaseChooseAnImageFile": "Please choose an image file",
    "imageMustBeUnder2Mb": "Image must be under 2 MB",
    "couldNotUploadImage": "Could not upload image",
    "couldNotRemoveProfilePhoto": "Could not remove profile photo",
    "platformOperatorsMustUseTheMasterConsoleLogin": "Platform operators must use the master console login URL.",
    "thisAccountIsNotAPlatformMasterAdministrator": "This account is not a platform master administrator.",
    "platformOperatorsMustSignInFromTheMaster": "Platform operators must sign in from the master console URL.",
    "failedToChangePassword": "Failed to change password",
    "enterANewPassword": "Enter a new password",
    "passwordActionFailed": "Password action failed",
    "couldNotLoadMfaStatus": "Could not load MFA status",
    "couldNotStartMfaSetup": "Could not start MFA setup",
    "invalidAuthenticatorCode": "Invalid authenticator code",
    "couldNotSaveNotificationPreferences": "Could not save notification preferences",
    "couldNotOpenModule": "Could not open {{module}}"
  },
  "moduleLogin": {
    "signedInAs": "Signed in as {{email}}",
    "currentlyIn": "You are currently in {{current}}.",
    "openInstead": "Open {{target}} instead?",
    "openModule": "Open {{module}}",
    "openingModule": "Opening {{module}}…"
  },
  "pages": {
    "myProfile": "My profile",
    "accountDetailsAppearanceAndSecurity": "Account details, appearance, and security",
    "twoFactorAuthentication": "Two-factor authentication",
    "completingLogin": "Completing login",
    "changeYourPassword": "Change your password"
  },
  "profile": {
    "sections": {
      "account": "Account",
      "preferences": "Preferences",
      "security": "Security"
    },
    "signInRequired": "Sign in to view your profile.",
    "mfaEnabled": "MFA enabled",
    "removePhoto": "Remove photo",
    "uploadPhoto": "Upload photo",
    "uploadingPhoto": "Uploading…"
  },
  "labels": {
    "changeProfilePhoto": "Change profile photo",
    "profileSections": "Profile sections",
    "email": "Email",
    "name": "Name",
    "role": "Role",
    "authenticatorCode": "Authenticator code",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmNewPassword": "Confirm new password"
  }
}
